import "./EmptyStatePlaceholder.scss";

function EmptyStatePlaceholder({ topText, bottomText }) {
  return (
    <div className="empty-state-placeholder">
      <div>
        {topText}
        {bottomText && (
          <>
            <br />
            <span className="empty-state-bottom-text">{bottomText}</span>
          </>
        )}
      </div>
    </div>
  );
}

export default EmptyStatePlaceholder;
